function extracted(binders, binderId) {
  return binders.filter(binder => binder.binderId === binderId);
}

export const customerModule = {
  namespaced: true,
  state: {
    customer: null,
    library: null,
    needsSaved: false
  },
  mutations: {
    setCustomer(state, customer) {
      state.customer = customer;
    },
    setLibrary(state, library) {
      state.library = library;
    },
    registerB(state, binderId) {
      let filteredBinders = extracted(state.library, binderId);
      if (filteredBinders.length) {
        filteredBinders[0].register = true;
      }
    },
    unregister(state, binderId) {
      let filteredBinders = extracted(state.library, binderId);
      if (filteredBinders.length) {
        filteredBinders[0].register = "";
      }
    },
    deregister(state, binderId) {
      let filteredBinders = extracted(state.library, binderId);
      if (filteredBinders.length) {
        filteredBinders[0].register = false;
      }
    },
    setRegisterAmount(state, binderId, amount) {
      let filteredBinders = extracted(state.library, binderId);
      if (filteredBinders.length) {
        filteredBinders[0].registerAmount = amount;
      }
    },
    setDeRegisterUsableAmount(state, binderId, amount) {
      let filteredBinders = extracted(state.library, binderId);
      if (filteredBinders.length) {
        filteredBinders[0].deRegisterUsableAmount = amount;
      }
    },
    setDeRegisterNotUsableAmount(state, binderId, amount) {
      let filteredBinders = extracted(state.library, binderId);
      if (filteredBinders.length) {
        filteredBinders[0].deRegisterNotUsableAmount = amount;
      }
    },
    setNeedsSaved(state) {
      state.needsSaved = true;
    },
    clearNeedsSaved(state) {
      state.needsSaved = false;
    }
  }
};
